/** @return {import("os")} */
const os = () => window.nodeModules?.os;

export default os;
